export default __webpack_public_path__ + "static/media/DSC_0018.5dcbd65f.jpg";